const FINGO_BLOG_URL = 'https://blog.fingo.cl/blogs-fingo';
const HELP_CENTER_URL = 'https://ayuda.fingo.cl/es-cl';
const BIZNEO_WIDGET_URL = 'https://empleos.fingo.cl/jobs_preview';
const BIZNEO_WIDGET_SOURCE_URL = 'https://empleos.fingo.cl';
const MAPS_LINK_CHILE = 'https://www.google.com/maps/place/Av.+Apoquindo+4660,+Las+Condes,+Regi%C3%B3n+Metropolitana,+Chile/@-33.4124645,-70.5832489,17z/data=!3m1!4b1!4m5!3m4!1s0x9662cf220e058827:0xb5ca3afbfd2b9c82!8m2!3d-33.4124645!4d-70.5810602';
const MAPS_LINK_MEXICO = 'https://www.google.com/maps/place/WeWork+Espacio+de+Oficinas+%26+Coworking/@19.4244733,-99.1702714,17z/data=!3m2!4b1!5s0x85d1ff49e1c5e921:0xa5aee7cd4f00e646!4m6!3m5!1s0x85d1ff49e05922bf:0xf5a129a2dab66b7c!8m2!3d19.4244733!4d-99.1676965!16s%2Fg%2F11cn972cqy?entry=ttu&g_ep=EgoyMDI1MTEwMi4wIKXMDSoASAFQAw%3D%3D';
const LINKEDIN_LINK = 'https://www.linkedin.com/company/fingomas/';
const INSTAGRAM_LINK = 'https://www.instagram.com/___fingo/';
const WHATSAPP_LINK = 'https://api.whatsapp.com/send?phone=15559641138&text=Hola%20buenos%20d%C3%ADas!%20%F0%9F%91%8B';
const CORPORATIVE_VIDEO_1_URL = 'https://www.youtube.com/watch?v=ilEtUaC9IsI';
const CORPORATIVE_VIDEO_2_URL = 'https://www.youtube.com/watch?v=NaPTqhX3SWk';
const FINGO_FIVE_YEARS_URL = 'https://www.youtube.com/watch?v=U1ayvv_mKkI';
const TUTORIAL_VIDEO_URL = 'https://www.youtube.com/watch?v=VkfpH_R3E1E';

export {
  FINGO_BLOG_URL,
  HELP_CENTER_URL,
  BIZNEO_WIDGET_URL,
  BIZNEO_WIDGET_SOURCE_URL,
  MAPS_LINK_CHILE,
  MAPS_LINK_MEXICO,
  LINKEDIN_LINK,
  INSTAGRAM_LINK,
  WHATSAPP_LINK,
  CORPORATIVE_VIDEO_1_URL,
  CORPORATIVE_VIDEO_2_URL,
  TUTORIAL_VIDEO_URL,
  FINGO_FIVE_YEARS_URL,
};
